import React, { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const TextEditor = (props) => {
  const { description, setDescription } = props;

  useEffect(() => {
  }, [description]);

  return (
    <ReactQuill
      theme="snow"
      value={description}
      onChange={setDescription}
      style={{ height: "200px", marginBottom: "50px"}}
    />
  );
};
